import {
  Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Inject, Optional
} from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';

import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { GroupingAndOrderingService } from '@ispm/shared/services/grouping-and-ordering.service';
import { cloneDeep, get, groupBy,sortBy, isEmpty } from 'lodash';


@Component({
  selector: 'gen-group-table-container',
  templateUrl: './group-table.component.html',
  styleUrls: ['./group-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent()
export class GroupTableComponent implements OnInit, IWidgetItem {
  public tableData: any = [];
  public formItems: any;
  public data: any = [];
  public viewAll: boolean = false;
  public hiddenCount: number = 0;
  public hiddenCount_item: number = 0;
  public showHiddenMessageWithCurrent: boolean;
  public totalItems: number = 0;
  public showGroupWithTitle: boolean = false;
  public groupedTableData: any;

  constructor(protected groupingAndOrderingService: GroupingAndOrderingService,
              private _changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {

  }

  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.formItems = _itemConfig.widgetPayload;
    this.formItems = Object.assign({}, this.formItems, { viewAsTable: get(this.formItems, 'viewAsTable', true)});
    this.viewAll = this.formItems.viewAll;
    this.showGroupWithTitle = this.formItems.showGroupWithTitle;
  }

  set widgetData(widgetData: any) {
    this.data = cloneDeep(widgetData);
    this.tableData = [];
    if (this.data && !isEmpty(this.data)) {
      this.totalItems = this.data.length;
      if (this.data, this.formItems.groupBy && this.formItems.groupOrderAttribute && this.formItems.orderBy && !this.viewAll) {
        this.data = this.groupingAndOrderingService.getGrouppedAndOrderedDataStructureByGroupIds
        (this.data, this.formItems.groupBy, this.formItems.groupOrderAttribute,
          this.formItems.orderBy, this.formItems.groupMaxCount, this.formItems.showCount);

      }

      if (this.data, this.formItems.groupBy && this.formItems.groupOrderAttribute && this.formItems.orderBy && this.viewAll) {
        this.data = this.groupingAndOrderingService.getGrouppedAndOrderedDataStructureViewAll
        (this.data, this.formItems.groupBy, this.formItems.groupOrderAttribute,
          this.formItems.orderBy);
      }

      if (this.data, this.formItems.orderBy && this.formItems.order) {
          this.groupingAndOrderingService.sortDataByDate(this.data,this.formItems.orderBy,this.formItems.order)
        }
  

      if (this.formItems.groupMaxCount != undefined) {
        if (widgetData.length > this.formItems.showCount) {
          this.tableData = this.data.slice(0, this.formItems.showCount);
          this.hiddenCount_item = widgetData.length - this.formItems.showCount;
        } else {
          this.tableData = this.data;
        }
      } else {
        if (this.formItems.showCount && this.data.length > this.formItems.showCount) {
          this.tableData = this.data.slice(0, this.formItems.showCount);
          this.hiddenCount = this.data.length - this.formItems.showCount;
        } else {
          this.tableData = this.data;
          if(!this.viewAll && this.formItems.showCount) {
            this.hiddenCount = this.data.length - this.formItems.showCount;
          }
        }
      }

      if(this.showGroupWithTitle && this.formItems.groupBy) {
        this.groupedTableData = groupBy(this.tableData, item => get(item, this.formItems.groupBy));
      }

      if(this.formItems.groupBy && this.formItems.showCountColumn ) {
       let groupedTableData = groupBy(sortBy(this.tableData,['index']), item => get(item, this.formItems.groupBy))
        if(groupedTableData){
          let tempDataArray =[];
          let countColumnName = this.formItems.countColumnName;
          for(let key in groupedTableData){
            let groupItemData = get(groupedTableData, key);
            if(groupItemData && groupItemData.length>0) {
              let countColumnObj = {};
              let rowData = groupItemData[0];
              countColumnObj[countColumnName] = groupItemData.length;
              rowData =Object.assign(rowData,countColumnObj);
              tempDataArray.push(rowData);

            }
          }
          this.tableData = tempDataArray;
        }
      }
    }
    else {
      this.groupedTableData = {};
      this.hiddenCount = 0;
      this.totalItems = 0;
    }
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

}
